module.exports = {
      id: "share-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#share",
      toString: function () {
        return this.url;
      }
    }